"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _getImageUrl = _interopRequireDefault(require("../../../Utils/getImageUrl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var styles = function styles() {
  return {
    tableWrapper: {
      padding: '0 0 25px 0'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      '& tr:nth-of-type(odd)': {
        backgroundColor: '#f3f3f3'
      }
    },
    title: {
      fontWeight: 'bold',
      textWrap: 'wrap'
    },
    field: {
      padding: '12px 15px',
      paddingRight: '10px'
    },
    row: {
      borderBottom: '1px solid #dddddd',
      width: '100%'
    },
    options: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '5px',
      marginTop: '5px'
    },
    option: {
      marginLeft: '10px',
      width: '180px'
    },
    image: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      "float": 'left',
      height: '100%',
      maxHeight: '100%',
      maxWidth: '80px',
      marginRight: '10px',
      fontSize: 0,
      '& img': {
        maxHeight: '100%',
        maxWidth: '100%'
      }
    }
  };
};
var ConfigurationOverview = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfigurationOverview, _React$Component);
  var _super = _createSuper(ConfigurationOverview);
  function ConfigurationOverview() {
    _classCallCheck(this, ConfigurationOverview);
    return _super.apply(this, arguments);
  }
  _createClass(ConfigurationOverview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        optionclassifications = _this$props.optionclassifications,
        classes = _this$props.classes;
      var renderImage = function renderImage(thumbnail) {
        var src = (0, _getImageUrl["default"])(thumbnail);
        return src && /*#__PURE__*/_react["default"].createElement("img", {
          src: src
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.tableWrapper
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: classes.table
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, optionclassifications === null || optionclassifications === void 0 ? void 0 : optionclassifications.map(function (optionclassification) {
        var _optionclassification;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !optionclassification.hiddenInFrontend && /*#__PURE__*/_react["default"].createElement("tr", {
          className: classes.row
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: classes.field,
          width: '35%'
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          className: classes.title
        }, optionclassification.title)), /*#__PURE__*/_react["default"].createElement("td", {
          className: classes.field
        }, (_optionclassification = optionclassification.selectedoptions) === null || _optionclassification === void 0 ? void 0 : _optionclassification.map(function (option) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: classes.options
          }, option.amount !== 1 ? /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.image
          }, renderImage((0, _get["default"])(option, 'thumbnail', '')), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            className: classes.option
          }, option.amount, " x ", option.title)) : /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.image
          }, renderImage((0, _get["default"])(option, 'thumbnail', '')), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            className: classes.option
          }, option.title)));
        }))));
      }))));
    }
  }]);
  return ConfigurationOverview;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'ConfigurationOverview'
})(ConfigurationOverview);